import { render } from "./EqualsIcon.vue?vue&type=template&id=16faf53f"
import script from "./EqualsIcon.vue?vue&type=script&lang=js"
export * from "./EqualsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__